export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://static.readdy.ai/image/31c62e42039e6e289d97944d8b0d7aa6/77cdc51489c74956193760ddc20e31c5.jpeg"
                alt="Sorto's Premier Roofing"
                className="w-12 h-12 object-contain"
              />
              <h3 className="text-xl font-bold">Sorto's Premier Roofing</h3>
            </div>
            <p className="text-gray-400 text-sm mb-6 leading-relaxed">
              Professional roofing services with guaranteed quality and fast service for residential and commercial properties.
            </p>
            <div className="flex items-center gap-3">
              <a href="tel:4172295037" className="w-10 h-10 bg-orange-500 hover:bg-orange-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-phone-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-orange-500 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-orange-500 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-orange-500 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6 border-b-2 border-orange-500 inline-block pb-2">Services</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">
                  Roof Repair
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">
                  Roof Replacement
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('free-inspection')} className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">
                  Free Inspection
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">
                  Emergency Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">
                  Gutters Installation
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">
                  Siding & Windows
                </button>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-lg font-bold mb-6 border-b-2 border-orange-500 inline-block pb-2">Company</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('warranty')} className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">
                  Warranty
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">
                  Contact
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">
                  Careers
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-6 border-b-2 border-orange-500 inline-block pb-2">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-fill text-orange-500 mt-1"></i>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Call Us</p>
                  <a href="tel:4172295037" className="text-white hover:text-orange-500 font-semibold cursor-pointer">
                    (417) 229-5037
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-orange-500 mt-1"></i>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Hours</p>
                  <p className="text-white text-sm">Mon-Fri: 7AM-6PM</p>
                  <p className="text-white text-sm">Sat: 8AM-4PM</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-center md:text-left">
              <p className="text-3xl font-bold text-white mb-2">SORTO'S</p>
              <div className="w-24 h-1 bg-orange-500 mb-3"></div>
              <p className="text-sm text-gray-400">
                © {new Date().getFullYear()} Sorto's Premier Roofing And Const LLC. All rights reserved.
              </p>
            </div>
            <div className="text-center md:text-right">
              <p className="text-sm text-gray-400">
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-orange-500 transition-colors cursor-pointer">
                  Powered by Readdy
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
